/**
 * Lädt eine externe CSS-Datei basierend auf dem customCssUrl URL-Parameter
 * Diese Funktion wird beim Start der Anwendung aufgerufen
 * 
 * HINWEIS: Für lokale HTTP-URLs wird die CSS inline geladen, um Mixed Content Probleme zu vermeiden
 */
export const loadExternalCss = (): void => {
  try {
    // URL-Parameter aus der aktuellen URL auslesen
    const urlParams = new URLSearchParams(window.location.search);
    const customCssUrl = urlParams.get('customCssUrl');

    // Wenn kein customCssUrl-Parameter vorhanden ist, nichts tun
    if (!customCssUrl) {
      console.log('[CSS Loader] Kein customCssUrl Parameter gefunden');
      return;
    }

    // Dekodiere die URL (falls sie URL-encodiert ist)
    const decodedCssUrl = decodeURIComponent(customCssUrl);
    console.log('[CSS Loader] Lade externe CSS-Datei:', decodedCssUrl);

    // Prüfe, ob die CSS-Datei bereits geladen wurde
    const existingLink = document.querySelector(`link[href="${decodedCssUrl}"]`);
    const existingStyle = document.querySelector(`style[data-css-url="${decodedCssUrl}"]`);
    if (existingLink || existingStyle) {
      console.log('[CSS Loader] CSS-Datei wurde bereits geladen');
      return;
    }

    // Prüfe auf Mixed Content (HTTPS-Seite lädt HTTP-Ressource)
    const pageIsHttps = window.location.protocol === 'https:';
    const cssIsHttp = decodedCssUrl.startsWith('http://');
    const isMixedContent = pageIsHttps && cssIsHttp;

    if (isMixedContent) {
      console.warn('[CSS Loader] Mixed Content erkannt - lade CSS via fetch und füge inline ein');
      // Lade CSS via fetch und füge es inline ein, um Mixed Content zu vermeiden
      fetch(decodedCssUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then(cssText => {
          const style = document.createElement('style');
          style.setAttribute('data-css-url', decodedCssUrl);
          style.textContent = cssText;
          document.head.appendChild(style);
          console.log('[CSS Loader] ✓ CSS inline eingefügt (Mixed Content Workaround)');
        })
        .catch(error => {
          console.error('[CSS Loader] ✗ Fehler beim Laden der CSS-Datei via fetch:', decodedCssUrl, error);
        });
      return;
    }

    // Normale Methode: <link>-Element erstellen
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = decodedCssUrl;
    
    // Füge Event-Listener hinzu, um Erfolg/Fehler zu loggen
    link.onload = () => {
      console.log('[CSS Loader] ✓ Externe CSS-Datei erfolgreich geladen:', decodedCssUrl);
    };
    
    link.onerror = () => {
      console.error('[CSS Loader] ✗ Fehler beim Laden der CSS-Datei:', decodedCssUrl);
      console.error('[CSS Loader] Mögliche Ursachen: CORS-Fehler, Datei nicht gefunden, oder Netzwerkfehler');
    };

    // Füge das <link>-Element zum <head> hinzu
    document.head.appendChild(link);
    
    console.log('[CSS Loader] <link>-Element zum <head> hinzugefügt');
  } catch (error) {
    console.error('[CSS Loader] Fehler beim Verarbeiten von customCssUrl:', error);
  }
};

